<div class="app-table-container">
  <div class="app-table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort
           [matSortActive]="sort[0]" [matSortDirection]="sort[1]"
           [matSortDisableClear]="true">

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let row" class="secondary">#{{row.id}}</td>
      </ng-container>

      <ng-container matColumnDef="surname" sticky>
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Фамилия</th>
        <td mat-cell *matCellDef="let row">
          <a [routerLink]="['/users/', row.id]">{{row.surname}}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Имя</th>
        <td mat-cell *matCellDef="let row">
          <a [routerLink]="['/users/', row.id]">{{row.name}}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="patronymic">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Отчество</th>
        <td mat-cell *matCellDef="let row">
          <a [routerLink]="['/users/', row.id]">{{row.patronymic}}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="mail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Почта</th>
        <td mat-cell *matCellDef="let row">{{row.mail}}</td>
      </ng-container>

      <ng-container matColumnDef="registerDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Зарегистрирован</th>
        <td mat-cell *matCellDef="let row">
          <app-time-event [value]="row.registerDate"></app-time-event>
        </td>
      </ng-container>

      <ng-container matColumnDef="blockDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Заблокирован</th>
        <td mat-cell *matCellDef="let row">
          <app-time-event *ngIf="row.blockDate" [value]="row.blockDate"></app-time-event>
        </td>
      </ng-container>

      <ng-container matColumnDef="roles">
        <th mat-header-cell *matHeaderCellDef>Роли</th>
        <td mat-cell *matCellDef="let row">{{formatRoles(row.roles)}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>

    <div class="spinner-container" *ngIf="dataSource.loading$|async">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <mat-paginator [length]="dataSource.totalElements$|async"
                 [pageSize]="pageSize"
                 [pageSizeOptions]="pageSizeOptions"
                 [pageIndex]="pageNumber"></mat-paginator>

</div>
